import {
    SET_CURRENT_MANIFEST,
    SET_DATA_SOURCE,
    LOADING_DATA,
    LOAD_DATA_SUCCESS,
    LOAD_DATA_FAILURE,
    ModeActions
} from "./action";
import StorageManager from '../../utils/StorageManager';

const initialState = {
    manifestPath: process.env.REACT_APP_MANIFEST_PATH || "/home/ubuntu/burrow-app/manifest-updates",
    currentManifest: null,
    dataSource: {
        source: null,
        movies: []  // Initialize with empty array to avoid undefined
    },
    loading: false,
    error: null,
    lastUpdated: null,
    initialized: false,
    isAdminMode: false, // Admin mode state
    isAdminPanelOpen: false,
    // Update autoplay configuration to remove randomMode and set default values
    autoplay: {
        enabled: false,
        durationType: 'all', // 'all', 'clips', 'shorts', 'films'
        currentPlaylist: [],
        currentVideoIndex: -1,
        randomMode: false // Mystery Box random autoplay
    },
    search: {
        results: [],
        loading: false,
        error: null,
        filters: {
            query: '',
            tags: [],
            minDuration: 0,
            maxDuration: 180,
            includeTitle: true,
            includeDescription: true,
            includeTags: true,
            page: 1,
            limit: 20,
            viewMode: 'grid'
        },
        totalResults: 0,
        recentSearches: StorageManager.get('recentSearches', [])
    },
    viewingMode: 'all', // 'all', 'films', 'shorts', 'clips'
    modeAutoplay: {
        films: false,
        shorts: false,
        clips: true
    },
    admin: {
        userSearch: {
            loading: false,
            results: [],
            totalResults: 0,
            error: null,
            filters: {
                query: '',
                page: 1,
                limit: 20,
                viewMode: 'grid'
            }
        },
        selectedUser: null,
        updateLoading: false,
        updateError: null
    },
    community: {
        userSearch: {
            results: [],
            loading: false,
            error: null,
            filters: {
                query: '',
                page: 1,
                limit: 10
            },
            totalResults: 0,
            currentPage: 1,
            totalPages: 1,
            hasMore: false,
            viewMode: 'grid' // 'grid' or 'list'
        }
    },
};

export const ModeReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CURRENT_MANIFEST':
            return { 
                ...state, 
                currentManifest: action.payload 
            };
        case 'SET_DATA_SOURCE':
            return {
                ...state,
                dataSource: action.payload,
                lastUpdated: new Date().toISOString()
            };
        case 'LOADING_DATA':
            return {
                ...state,
                loading: true,
                error: null
            };
        case 'LOAD_DATA_SUCCESS':
            return {
                ...state,
                loading: false,
                dataSource: action.payload,
                lastUpdated: new Date().toISOString(),
                error: null
            };
        case 'LOAD_DATA_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case ModeActions.SET_ADMIN_MODE:
            return {
                ...state,
                isAdminMode: action.payload
            };
        // Admin panel actions
        case ModeActions.OPEN_ADMIN_PANEL:
            return {
                ...state,
                isAdminPanelOpen: true
            };
        case ModeActions.CLOSE_ADMIN_PANEL:
            return {
                ...state,
                isAdminPanelOpen: false
            };
        case ModeActions.SEARCH_VIDEOS_REQUEST:
            return {
                ...state,
                search: {
                    ...state.search,
                    loading: true,
                    error: null
                }
            };
        case ModeActions.SEARCH_VIDEOS_SUCCESS:
            return {
                ...state,
                search: {
                    ...state.search,
                    loading: false,
                    results: action.payload.results,
                    totalResults: action.payload.totalResults,
                    error: null
                }
            };
        case ModeActions.SEARCH_VIDEOS_FAILURE:
            return {
                ...state,
                search: {
                    ...state.search,
                    loading: false,
                    error: action.payload
                }
            };
        case ModeActions.UPDATE_SEARCH_FILTERS:
            return {
                ...state,
                search: {
                    ...state.search,
                    filters: {
                        ...state.search.filters,
                        ...action.payload
                    }
                }
            };
        case ModeActions.CLEAR_SEARCH:
            return {
                ...state,
                search: {
                    ...state.search,
                    results: [],
                    filters: {
                        ...initialState.search.filters
                    },
                    error: null
                }
            };
        case ModeActions.SET_SEARCH_VIEW_MODE:
            return {
                ...state,
                search: {
                    ...state.search,
                    filters: {
                        ...state.search.filters,
                        viewMode: action.payload
                    }
                }
            };
        case ModeActions.UPDATE_SEARCH_HISTORY:
            return {
                ...state,
                search: {
                    ...state.search,
                    recentSearches: action.payload
                }
            };
        // Add new cases for autoplay actions
        case ModeActions.SET_AUTOPLAY_ENABLED:
            return {
                ...state,
                autoplay: {
                    ...state.autoplay,
                    enabled: action.payload
                }
            };
            
        case ModeActions.SET_AUTOPLAY_DURATION_TYPE:
            return {
                ...state,
                autoplay: {
                    ...state.autoplay,
                    durationType: action.payload
                }
            };
            
        case ModeActions.SET_AUTOPLAY_PLAYLIST:
            return {
                ...state,
                autoplay: {
                    ...state.autoplay,
                    currentPlaylist: action.payload.playlist,
                    currentVideoIndex: action.payload.currentIndex
                }
            };
            
        case ModeActions.UPDATE_CURRENT_VIDEO_INDEX:
            return {
                ...state,
                autoplay: {
                    ...state.autoplay,
                    currentVideoIndex: action.payload
                }
            };

        case ModeActions.SET_RANDOM_AUTOPLAY:
            return {
                ...state,
                autoplay: {
                    ...state.autoplay,
                    randomMode: action.payload
                }
            };

        case ModeActions.SET_VIEWING_MODE:
            return {
                ...state,
                viewingMode: action.payload
            };

        case ModeActions.SET_FILMS_AUTOPLAY:
            return {
                ...state,
                modeAutoplay: {
                    ...state.modeAutoplay,
                    films: action.payload
                }
            };

        case ModeActions.SET_SHORTS_AUTOPLAY:
            return {
                ...state,
                modeAutoplay: {
                    ...state.modeAutoplay,
                    shorts: action.payload
                }
            };

        case ModeActions.SET_CLIPS_AUTOPLAY:
            return {
                ...state,
                modeAutoplay: {
                    ...state.modeAutoplay,
                    clips: action.payload
                }
            };
        case ModeActions.ADMIN_SEARCH_USERS_REQUEST:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    userSearch: {
                        ...state.admin.userSearch,
                        loading: true,
                        error: null
                    }
                }
            };
        case ModeActions.ADMIN_SEARCH_USERS_SUCCESS:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    userSearch: {
                        ...state.admin.userSearch,
                        loading: false,
                        results: action.payload.results,
                        totalResults: action.payload.totalResults,
                        error: null
                    }
                }
            };
        case ModeActions.ADMIN_SEARCH_USERS_FAILURE:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    userSearch: {
                        ...state.admin.userSearch,
                        loading: false,
                        error: action.payload
                    }
                }
            };
        case ModeActions.ADMIN_UPDATE_USER_FILTERS:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    userSearch: {
                        ...state.admin.userSearch,
                        filters: {
                            ...state.admin.userSearch.filters,
                            ...action.payload
                        }
                    }
                }
            };
        case ModeActions.ADMIN_SET_USER_VIEW_MODE:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    userSearch: {
                        ...state.admin.userSearch,
                        filters: {
                            ...state.admin.userSearch.filters,
                            viewMode: action.payload
                        }
                    }
                }
            };
        case ModeActions.ADMIN_SET_SELECTED_USER:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    selectedUser: action.payload
                }
            };
        case ModeActions.ADMIN_CLEAR_SELECTED_USER:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    selectedUser: null
                }
            };
        case ModeActions.ADMIN_UPDATE_USER_REQUEST:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    updateLoading: true,
                    updateError: null
                }
            };
        case ModeActions.ADMIN_UPDATE_USER_SUCCESS:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    updateLoading: false,
                    selectedUser: action.payload,
                    userSearch: {
                        ...state.admin?.userSearch,
                        // Also update the user in the search results list
                        results: (state.admin?.userSearch?.results || []).map(u =>
                            u._id === action.payload?._id ? { ...u, ...action.payload } : u
                        )
                    }
                }
            };
        case ModeActions.ADMIN_UPDATE_USER_FAILURE:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    updateLoading: false,
                    updateError: action.payload
                }
            };
        case 'COMMUNITY_USER_SEARCH_REQUEST':
            return {
                ...state,
                community: {
                    ...state.community,
                    userSearch: {
                        ...state.community.userSearch,
                        loading: true,
                        error: null
                    }
                }
            };
        case 'COMMUNITY_USER_SEARCH_SUCCESS':
            return {
                ...state,
                community: {
                    ...state.community,
                    userSearch: {
                        ...state.community.userSearch,
                        loading: false,
                        error: null,
                        results: action.payload.results,
                        totalResults: action.payload.totalResults,
                        currentPage: action.payload.currentPage,
                        totalPages: action.payload.totalPages,
                        hasMore: action.payload.hasMore
                    }
                }
            };
        case 'COMMUNITY_USER_SEARCH_FAILURE':
            return {
                ...state,
                community: {
                    ...state.community,
                    userSearch: {
                        ...state.community.userSearch,
                        loading: false,
                        error: action.payload
                    }
                }
            };
        default:
            return state;
    }
};
